import React from "react";

// import MadamFelleLandingPagePopup from "./madam-felle/landing-page-popup";

const mods = {
	landingpage: {
		// 'madam-felle-landing-page-popup': {
		// 	type: 'component',
		// 	exec: MadamFelleLandingPagePopup
		// }
	}
}

export default function Modules(props) {
	const { modules } = window;
	const { data, page } = props;

	const ret = [];

	if(mods[page] !== undefined) {
		for(let module in mods[page]) {
			if(modules.indexOf(module) > -1) {
				const m = mods[page][module];

				if(m.type === 'func') {
					ret.push(m.exec(data));
				} else if(m.type === 'component') {
					ret.push(React.createElement(m.exec, {key: module, ...data}));
				}
			}
		}
	}

	if(ret.length === 0)
		return null;

	return ret;
}


// WEBPACK FOOTER //
// ./src/components/modules/index.js